import { IAction, IMessageElement, IMessage } from "@chainlit/components";

export interface DialogEntry {
  messages: IMessage[];
  actions: IAction[];
  elements: IMessageElement[];
}

export const dialog_1: DialogEntry[] = [
  {
    actions: [],
    elements: [],
    messages: [
      {
        id: "1",
        createdAt: 0,
        author: "AgGPT",
        content:
          "Claro, permíteme un momento mientras recolecto la información más reciente.",
        subMessages: [
          {
            id: "1_tool",
            createdAt: 0,
            author: "API Clima",
            content:
              "AgGPT accede a la API de clima personalizada para obtener los datos climáticos de la última semana en la localidad de Casablanca.",
          },
        ],
      },
      {
        id: "2",
        createdAt: 1,
        author: "AgGPT",
        content:
          "He recopilado los datos. Durante la última semana, tu viñedo en Casablanca tuvo temperaturas promedio de **23°C** con una humedad relativa del **60%**. Hubo dos días de lluvia ligera, acumulando un total de 5mm de precipitación.",
        subMessages: [
          {
            id: "2_tool",
            createdAt: 0,
            author: "RAG Datos Históricos",
            content:
              "AgGPT utiliza RAG para sintetizar los datos climáticos y los reportes de cultivo de la aplicación del cliente.",
          },
        ],
      },
      {
        id: "3",
        createdAt: 2,
        author: "AgGPT",
        content:
          "Basado en estos datos y en los registros históricos de tu viñedo, las condiciones han sido generalmente beneficiosas. No obstante, para mantener la salud óptima de tus viñedos, sugiero incrementar el riego ligeramente durante los próximos días para compensar la menor precipitación y mantener la humedad del suelo adecuada. En particular, considerando que tu cultivo en Casablanca es de Cerezas, y considerando la Evapotranspiración obtenida, te recomendaría aplicar ciclos de riego de 60 minutos cada 12 horas.",
      },
    ],
  },
  {
    elements: [],
    actions: [
      {
        id: "send_report",
        forId: "4",
        name: "Enviar reporte",
        value: "Enviar reporte",
        onClick() {},
        collapsed: false,
      },
    ],
    messages: [
      {
        id: "4",
        createdAt: 3,
        author: "AgGPT",
        content:
          "Por supuesto. Prepararé un resumen ejecutivo que incluirá un análisis detallado del clima de la semana pasada, el estado actual de tus cultivos y las recomendaciones de manejo para la próxima semana. Te lo enviaré en breve.",
      },
    ],
  },
];

export const dialog_2: DialogEntry[] = [
  {
    actions: [],
    elements: [],
    messages: [
      {
        id: "1",
        createdAt: 0,
        author: "AgGPT",
        content:
          "Claro, permíteme un momento mientras recolecto la información más reciente.",
      },
      {
        id: "2",
        createdAt: 1,
        author: "AgGPT",
        content:
          "Accediendo a los reportes de calidad a través de la aplicación...",
        subMessages: [
          {
            id: "2_tool",
            createdAt: 0,
            author: "RAG Inspección de Calidad",
            content:
              "AgGPT utiliza la función RAG para recuperar los datos de inspección de calidad más recientes de la base de datos de la aplicación.",
          },
        ],
      },
      {
        id: "3",
        createdAt: 2,
        author: "AgGPT",
        content:
          "Los reportes indican que un 92% de la fruta inspeccionada cumple con los estándares de calidad. Un 8% presentó irregularidades leves que no comprometen su comercialización. La calidad general es alta, lo que es una excelente noticia para el mercado de exportación.",
      },
      {
        id: "4",
        createdAt: 3,
        author: "AgGPT",
        content:
          "Ahora, permíteme analizar las proyecciones para la próxima cosecha.",
        subMessages: [
          {
            id: "4_tool",
            createdAt: 0,
            author: "XGBoost Timeseries",
            content:
              "AgGPT utiliza modelos predictivos XGBoost timeseries basados en datos históricos y actuales para estimar la producción de la próxima semana tomando en cuenta el clima de la proxima semana.",
          },
        ],
      },
      {
        id: "5",
        createdAt: 4,
        author: "AgGPT",
        content:
          "Basado en la información histórica y las condiciones actuales, proyectamos que la cosecha de la próxima semana podría incrementarse en un 18%, manteniendo una calidad similar, siempre y cuando las condiciones climáticas no cambien drásticamente.",
      },
    ],
  },
  {
    elements: [],
    actions: [
      {
        id: "send_report",
        forId: "6",
        name: "Enviar reporte",
        value: "Enviar reporte",
        onClick() {},
        collapsed: false,
      },
    ],
    messages: [
      {
        id: "6",
        createdAt: 5,
        author: "AgGPT",
        content:
          "Por supuesto. Estoy generando un resumen ejecutivo que incluirá el análisis de calidad, las proyecciones de cosecha y recomendaciones para la próxima semana. También incorporaré gráficos para una mejor visualización de la información. Te enviaré el documento en breve.",
      },
    ],
  },
];

export const dialog_3: DialogEntry[] = [
  {
    elements: [],
    actions: [],
    messages: [
      {
        id: "1",
        createdAt: 0,
        author: "AgGPT",
        content:
          "Por supuesto, voy a revisar los reportes de la última temporada y te prepararé un resumen con las recomendaciones más importantes.",
        subMessages: [
          {
            id: "1_tool",
            createdAt: 0,
            author: "Base de Datos",
            content:
              "AgGPT accede a la base de datos de la aplicación para recuperar los reportes fitosanitarios de la última temporada.",
          },
        ],
      },
      {
        id: "2",
        createdAt: 1,
        author: "AgGPT",
        content:
          "Estoy analizando los reportes fitosanitarios y extrayendo las recomendaciones clave. Esto tomará un momento.",
        subMessages: [
          {
            id: "2_tool",
            createdAt: 1,
            author: "Procesamiento de Datos",
            content:
              "AgGPT utiliza técnicas de procesamiento de lenguaje natural y análisis de datos para sintetizar las recomendaciones fitosanitarias.",
          },
        ],
      },
      {
        id: "3",
        createdAt: 2,
        author: "AgGPT",
        content:
          "He completado el resumen ejecutivo. Durante la última temporada, se hicieron varias recomendaciones importantes, entre ellas la aplicación de tratamientos preventivos contra el mildiu debido a las altas humedades registradas, y la necesidad de monitorear de cerca la presencia de ácaros en las etapas tempranas de crecimiento de los cultivos.",
      },
    ],
  },
  {
    elements: [],
    actions: [],
    messages: [
      {
        id: "4",
        createdAt: 3,
        author: "AgGPT",
        content:
          "Así es. Cada recomendación en el resumen ejecutivo viene acompañada de un plan de acción detallado, incluyendo los productos fitosanitarios sugeridos, dosis, y el calendario de aplicación óptimo para prevenir futuros brotes de enfermedades y plagas.",
      },
    ],
  },
  {
    elements: [],
    actions: [
      {
        id: "send_email",
        forId: "5",
        name: "Enviar correo",
        value: "Enviar correo",
        onClick() {},
        collapsed: false,
      },
    ],
    messages: [
      {
        id: "5",
        createdAt: 4,
        author: "AgGPT",
        content:
          "Claro que sí. Incluiré en el correo electrónico el resumen ejecutivo con las recomendaciones y planes de acción, así como un anexo con los datos de contacto de los proveedores de los productos fitosanitarios que se mencionan en el informe. Te lo enviaré dentro de los próximos minutos.",
      },
    ],
  },
];

export const dialog_4: DialogEntry[] = [
  {
    actions: [],
    elements: [],
    messages: [
      {
        id: "1",
        createdAt: 0,
        author: "AgGPT",
        content:
          "Con gusto. Voy a preparar los gráficos interactivos basados en los datos más recientes. ¿Hay algún detalle específico que te interese resaltar en estos gráficos?",
      },
    ],
  },
  {
    actions: [],
    elements: [
      {
        id: "visitasMensuales",
        type: "plotly",
        forIds: ["2"], // Replace with the appropriate ID(s)
        name: "Visitas Mensuales a Campos",
        display: "inline",
        content: JSON.stringify({
          data: [
            {
              x: [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
              ],
              y: [120, 150, 170, 130, 160, 180, 200, 220, 190, 210, 230, 240], // Mockup data for visits
              type: "bar",
              name: "2023", // This is the year for the data
            },
            // Additional years can be added as separate traces
            // {
            //   x: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            //   y: [110, 130, 150, 120, 140, 160, 180, 200, 170, 190, 210, 220], // Mockup data for another year
            //   type: 'bar',
            //   name: '2022',
            // },
          ],
          layout: {
            width: 640,
            height: 400,
            title: "Visitas Mensuales a Campos",
            xaxis: {
              title: "Mes",
            },
            yaxis: {
              title: "Cantidad de Visitas",
            },
            barmode: "group",
            // To add the ability to filter by year, we can use updatemenus
            updatemenus: [
              {
                x: 0.1,
                y: 1.15,
                xref: "paper",
                yref: "paper",
                yanchor: "top",
                active: 0,
                showactive: true,
                buttons: [
                  {
                    method: "update",
                    args: [{ visible: [true, false] }], // Show 2023, hide other years
                    label: "2023",
                  },
                  // Additional buttons for other years
                  // {
                  //   method: 'update',
                  //   args: [{'visible': [false, true]}], // Hide 2023, show 2022
                  //   label: '2022'
                  // },
                ],
              },
            ],
          },
        }),
      },
    ],
    messages: [
      {
        id: "2",
        createdAt: 1,
        author: "AgGPT",
        content:
          "Entendido. Estoy generando el primer gráfico interactivo de 'Visitas mensuales'. Este gráfico te permitirá filtrar por mes y año, y verás la cantidad de visitas realizadas a cada campo.",
        subMessages: [
          {
            id: "2_tool",
            createdAt: 1,
            author: "Herramienta de Visualización",
            content:
              "AgGPT crea un gráfico interactivo de barras utilizando una herramienta de visualización de datos como Plotly, que permite al cliente filtrar y examinar las visitas mensuales a sus campos.",
          },
        ],
      },
    ],
  },
  {
    actions: [],
    elements: [
      {
        id: "distribucionCosechaCiruelas",
        type: "plotly",
        forIds: ["3"], // Replace with the appropriate ID(s)
        name: "Distribución de Cosecha de Ciruelas",
        display: "inline",
        content: JSON.stringify({
          data: [
            {
              values: [500, 300, 200, 400], // Mockup data for plum production
              labels: [
                "Ciruela Roja",
                "Ciruela Negra",
                "Ciruela Amarilla",
                "Ciruela Verde",
              ], // Plum varieties
              type: "pie",
              textinfo: "label+percent",
              insidetextorientation: "radial",
              marker: {
                colors: ["red", "black", "yellow", "green"], // Colors representing plum varieties
              },
            },
          ],
          layout: {
            width: 640,
            height: 400,
            title: "Distribución de Cosecha de Ciruelas",
          },
        }),
      },
      {
        id: "distribucionCosechaCerezas",
        type: "plotly",
        forIds: ["3"], // Replace with the appropriate ID(s)
        name: "Distribución de Cosecha de Cerezas",
        display: "inline",
        content: JSON.stringify({
          data: [
            {
              values: [600, 350, 250], // Mockup data for cherry production
              labels: ["Cereza Dulce", "Cereza Ácida", "Cereza Amarga"], // Cherry varieties
              type: "pie",
              textinfo: "label+percent",
              insidetextorientation: "radial",
              marker: {
                colors: ["darkred", "pink", "purple"], // Colors representing cherry varieties
              },
            },
          ],
          layout: {
            width: 640,
            height: 400,
            title: "Distribución de Cosecha de Cerezas",
          },
        }),
      },
    ],
    messages: [
      {
        id: "3",
        createdAt: 2,
        author: "AgGPT",
        content:
          "Ahora estoy preparando los gráficos de 'Distribución de cosecha de ciruelas' y 'Distribución de cosecha de cerezas'. Estos mostrarán la producción por variedad en gráficos de torta, permitiéndote identificar visualmente la contribución de cada variedad a la cosecha total.",
        subMessages: [
          {
            id: "3_tool",
            createdAt: 2,
            author: "Herramienta de Visualización",
            content:
              "AgGPT utiliza los datos de cosecha para crear gráficos de torta interactivos, diferenciando cada variedad de ciruela y cereza con colores distintos y leyendas claras.",
          },
        ],
      },
    ],
  },
  {
    actions: [],
    elements: [
      {
        id: "estimacionCosechaPorEspecie",
        type: "plotly",
        forIds: ["4"], // Replace with the appropriate ID(s)
        name: "Estimación de Cosecha por Especie",
        display: "inline",
        content: JSON.stringify({
          data: [
            {
              x: ["2018", "2019", "2020", "2021", "2022"], // Last five years
              y: [800, 820, 600, 900, 1200], // Mockup data for species A
              type: "scatter",
              mode: "lines+markers",
              name: "Especie A",
              line: { color: "blue" },
            },
            {
              x: ["2018", "2019", "2020", "2021", "2022"], // Last five years
              y: [950, 970, 850, 1000, 1100], // Mockup data for species B
              type: "scatter",
              mode: "lines+markers",
              name: "Especie B",
              line: { color: "green" },
            },
            // Add more species as needed
          ],
          layout: {
            width: 640,
            height: 400,
            title: "Estimación de Cosecha por Especie (Últimos 5 Años)",
            xaxis: {
              title: "Año",
            },
            yaxis: {
              title: "Producción (Toneladas)",
            },
            legend: {
              title: {
                text: "Especies",
              },
            },
          },
        }),
      },
    ],
    messages: [
      {
        id: "4",
        createdAt: 3,
        author: "AgGPT",
        content:
          "Finalmente, estoy generando el gráfico de 'Estimación de cosecha por especie' para los últimos cinco años. Este gráfico de líneas mostrará la tendencia de producción para cada especie, con la capacidad de seleccionar un rango de años específico para un análisis más detallado.",
        subMessages: [
          {
            id: "4_tool",
            createdAt: 3,
            author: "Herramienta de Visualización",
            content:
              "AgGPT elabora un gráfico de líneas interactivo con los datos históricos de producción, permitiendo al cliente ver las tendencias y hacer comparaciones año a año.",
          },
        ],
      },
    ],
  },
  {
    elements: [],
    actions: [
      {
        id: "send_link",
        forId: "5",
        name: "Enviar enlace",
        value: "Enviar enlace",
        onClick() {},
        collapsed: false,
      },
    ],
    messages: [
      {
        id: "5",
        createdAt: 4,
        author: "AgGPT",
        content:
          "Voy a enviarte un enlace que te dará acceso a un tablero interactivo donde podrás explorar todos estos gráficos. También podrás descargar los datos y los gráficos si necesitas presentarlos en alguna reunión o informe.",
        subMessages: [
          {
            id: "5_tool",
            createdAt: 4,
            author: "Herramienta de Visualización",
            content:
              "AgGPT prepara un tablero interactivo en una plataforma de visualización de datos y envía el enlace al cliente a través de su correo electrónico o un mensaje directo.",
          },
        ],
      },
    ],
  },
  {
    actions: [],
    elements: [],
    messages: [
      {
        id: "6",
        createdAt: 5,
        author: "AgGPT",
        content:
          "De nada. Si tienes alguna otra solicitud o necesitas asistencia adicional con los gráficos, no dudes en contactarme. Te enviaré el enlace en unos momentos.",
      },
    ],
  },
];
